@let showSkeleton = isLoading();
@let showEmpty = !isLoading() && groups().length === 0;

@if (showEmpty) {
  <bn-web-ui-not-available
    data-e2e="EventLogGroupsEmptyState"
    [options]="{ height: 'initial', title: 'No events found', description: 'There are no Shield events for the selected time range and filters.' }" />
} @else {
  <div class="bn-table bn-table--auto bn-table--primary bn-event-logs-groups-table">
    <table class="bn-table--normal">
      <thead>
        <th></th>
        <th class="whitespace-nowrap">Group</th>
        <th class="whitespace-nowrap">Events</th>
        <th class="whitespace-nowrap">Distribution</th>
        <th class="whitespace-nowrap">Last seen</th>
      </thead>
      <tbody>
        @if (!showSkeleton) {
          @for (group of groups(); track keyOf(group)) {
            @let key = keyOf(group);
            <tr
              class="cursor-pointer color-dark-7"
              data-e2e="EventLogGroupRow"
              (click)="onToggle(group)">
              <td>
                <fa-icon [icon]="openRows[key] ? 'chevron-up' : 'chevron-down'" />
              </td>
              <td>
                <div class="bn-event-logs-groups-table__key">
                  @for (part of keyParts(group); track part.dimension) {
                    <div class="bn-event-logs-groups-table__key-part">
                      <span class="bn-event-logs-groups-table__key-label">{{ part.label }}</span>
                      <span class="bn-event-logs-groups-table__key-value">
                        @switch (part.dimension) {
                          @case ('action') {
                            <bn-web-ui-badge
                              contentClass="text-uppercase"
                              size="sm"
                              type="tag"
                              [color]="actionColor(part.value)"
                              >{{ part.value }}</bn-web-ui-badge
                            >
                          }
                          @case ('country') {
                            <bn-web-ui-flag
                              [countryCode]="part.value"
                              [displayCountryName]="true"
                              [showTooltip]="false" />
                          }
                          @case ('ip') {
                            <bn-web-ui-flag [countryCode]="groupCountry(group)" />
                            <span class="bn-event-logs-groups-table__mono">{{ part.value }}</span>
                          }
                          @case ('asn') {
                            <span class="bn-event-logs-groups-table__mono">AS{{ part.value }}</span>
                          }
                          @default {
                            <span class="bn-event-logs-groups-table__mono">{{ part.value }}</span>
                          }
                        }
                      </span>
                    </div>
                  }
                </div>
              </td>
              <td>
                <bn-web-ui-badge
                  appearance="solid"
                  size="sm"
                  type="tag"
                  [color]="isHot(group) ? 'yellow' : 'base'"
                  >{{ group.count }}</bn-web-ui-badge
                >
              </td>
              <td>
                @if (sparkBars(group); as bars) {
                  <div
                    aria-hidden="true"
                    class="bn-event-logs-groups-table__spark">
                    @for (bar of bars; track $index) {
                      <span
                        class="bn-event-logs-groups-table__spark-bar"
                        [style.height.%]="bar"></span>
                    }
                  </div>
                } @else {
                  <span class="bn-event-logs-groups-table__muted">—</span>
                }
              </td>
              <td class="text-nowrap">
                <div class="bn-event-logs-groups-table__last-seen">
                  <span>{{ group.lastSeen | date: 'HH:mm:ss' }}</span>
                  <span class="bn-event-logs-groups-table__date">{{ group.lastSeen | date: 'MMM d' }}</span>
                </div>
              </td>
            </tr>

            @if (openRows[key]) {
              @let loaded = expandedGroupRows()[key];
              <tr class="no-hover">
                <td colspan="5">
                  <app-app-shield-event-logs-table
                    [compact]="true"
                    [isLoading]="isGroupLoading(key)"
                    [rows]="loaded?.rows ?? []" />
                  @if (loaded && loaded.total > nestedPageSize && !isGroupLoading(key)) {
                    <div
                      class="bn-event-logs-groups-table__nested-pagination"
                      data-e2e="EventLogGroupPagination">
                      <bn-web-ui-pagination
                        [settings]="{
                          currentPage: loaded.page + 1,
                          perPage: nestedPageSize,
                          queryParamEnabled: false,
                          scrollToTop: false,
                          totalItems: loaded.total,
                        }"
                        (page)="onNestedPageChange(group, $event)" />
                    </div>
                  }
                </td>
              </tr>
            }
          }
        }

        @if (showSkeleton) {
          <ng-template *ngTemplateOutlet="skeletonTemplates.logsSkeletonTemplate(); context: { columns: 5 }" />
        }
      </tbody>
    </table>
  </div>
}

<bn-web-ui-table-skeleton-template #skeletonTemplates />
